module.exports = __webpack_public_path__ + "img/d.1f0f6db1.png";